<template>
  <div>

    <!--      &lt;!&ndash;  使用iframe展示   支付宝二维码&ndash;&gt;-->
    <!--    <iframe id="alipayFrame" width="100%" height="900px "></iframe>-->
  </div>
</template>

<script>
import axios from 'axios';
import { Head } from 'vue-head';

export default {
  components: {
    Head,
  },
  data() {
    return {
      token: "",
      orderCode: "",
      code: "",
      timerId: null // 用于存储定时器的 ID
    };
  },
  mounted() {
    this.token = "Bearer " + localStorage.getItem("loginToken");
    this.orderCode = sessionStorage.getItem('orderCode');
    this.redirectToWeixinLogin();
  },
  methods: {
    redirectToWeixinLogin() {
      const baseURL = this.$http.defaults.baseURL.replace(/\/$/, '');
      const orderCode = this.orderCode;
      const token = this.token;

      // 构建请求路径
      const url = baseURL + `/yasubit/pay/aliPay?orderCode=${orderCode}`;
      // const url = `https://smartforest.cn:8080/yasubit/pay/aliPay?orderCode=${orderCode}`;

      // 使用 Axios 发起 GET 请求
      axios.get(url, {
        headers: {
          Authorization: token,
        },
      })
        .then(response => {
          // 根据需要处理响应
          console.log(response)
          this.code = response.data


          let divForm = document.getElementsByTagName('divform')
          if (divForm.length) {
            document.body.removeChild(divForm[0])
          }
          const div = document.createElement('divform');
          div.innerHTML = response.data
          document.body.appendChild(div);
          document.forms[0].setAttribute('target', '_blank')
          document.forms[0].submit();


        })
        .catch(error => {
          // 处理错误
          console.error(error);
        });

    },
  },

  //下面这种是iframe的方式进行支付码展示
  //   mounted() {
  //     this.token = "Bearer " + localStorage.getItem("loginToken");
  //     this.orderCode = sessionStorage.getItem('orderCode');
  //     this.redirectToWeixinLogin();
  //
  //   },
  //   methods: {
  // goIndex(){
  //   this.$router.push({path:"/"})
  // },
  // //监测测支付状态
  //     getPayStatus() {
  //       const orderCode = this.orderCode;
  //       const token = this.token;
  //       // 构建请求路径
  //       const url = `/yasubit/pay/getPayStatus?orderCode=${orderCode}`;
  //
  //       // 使用 Axios 发起 GET 请求
  //       axios.get(url, {
  //         headers: {
  //           Authorization: token,
  //         },
  //       })
  //           .then(response => {
  //             console.log("支付状态")
  //             // 根据需要处理响应
  //             console.log(response.data.msg)
  //             if(response.data.msg==="true"){
  //               //停止定时器
  //               clearInterval(this.timerId);
  //             this.$message.success("支付成功，即将在3秒后跳回首页")
  //               setTimeout(() => {
  //                 this.goIndex();
  //               }, 3000);
  //
  //             }
  //
  //           })
  //           .catch(error => {
  //             // 处理错误
  //             console.error(error);
  //           });
  //
  //     },
  //     //获取支付码嵌入页面
  //     redirectToWeixinLogin() {
  //
  //       const orderCode = this.orderCode;
  //       const token = this.token;
  //       // 构建请求路径
  //       const url = `/yasubit/pay/aliPay?orderCode=${orderCode}`;
  //       // 使用 Axios 发起 GET 请求
  //       axios.get(url, {
  //         headers: {
  //           Authorization: token,
  //         },
  //       })
  //           .then(response => {
  //             // 根据需要处理响应
  //             console.log(response.data)
  //             let o = document.getElementById("alipayFrame")
  //             let ed = document.getElementById ? o.contentWindow.document : o.contentDocument
  //             ed.open()
  //             ed.write(response.data) // 放入支付宝的表单数据
  //             ed.close()
  //             ed.contentEditable = true
  //             ed.designMode = 'on'
  //
  //             //监测支付状态进行轮询
  //
  //            this.timerId= setInterval(() => {
  //               this.getPayStatus();
  //             }, 2000);
  //
  //
  //
  //             // 设置超过半小时后停止定时器
  //             setTimeout(() => {
  //               clearInterval(this.timerId);
  //               console.log("超过半小时，停止定时器");
  //             }, 1800000);
  //
  //
  //           })
  //           .catch(error => {
  //             // 处理错误
  //             console.error(error);
  //           });
  //     },
  //
  //   },
  beforeDestroy() {
    // 在组件销毁之前清理定时器
    clearInterval(this.timerId);
  }
};
</script>
